<div class="wall-card-social-scroll">
<div class="wall-card-social-media">
  <ng-content select="[wallMedia]"></ng-content>
  <div class="eazix-exhibition-card-overlay"
    [class.is-off]="focusLayout"
    (click)="$event.stopPropagation()">
    <button type="button"
      class="eazix-exhibition-stat-btn eazix-exhibition-like-hit"
      [class.eazix-exhibition-stat-liked]="card.likedByMe"
      [disabled]="card.liking"
      (click)="onLike($event)"
      [attr.aria-label]="'wall.exhibition.like' | translate">
      <mat-icon>{{ card.likedByMe ? 'favorite' : 'favorite_border' }}</mat-icon>
      <ng-container *ngIf="showLikeCount">
        <span>{{ card.likeCount }}</span>
        <span *ngIf="card.likeCount > 0 && topLikers(card.recentLikers).length"
          class="eazix-exhibition-likers-tip"
          aria-hidden="true">
          <span *ngFor="let n of topLikers(card.recentLikers)"
            class="eazix-exhibition-likers-name"
            [attr.title]="n">{{ shortAuthorName(n) }}</span>
          <span *ngIf="card.likeCount > 3" class="eazix-exhibition-likers-more">...</span>
        </span>
      </ng-container>
    </button>
    <button *ngIf="!compactOverlay"
      type="button"
      class="eazix-exhibition-stat-btn"
      [class.eazix-exhibition-stat-active]="card.commentsOpen"
      (mouseenter)="ensureCommentersTip()"
      (click)="toggleComments($event)"
      [attr.aria-label]="'wall.exhibition.comments' | translate">
      <span class="eazix-exhibition-stat-icon eazix-exhibition-like-hit">
        <mat-icon>{{ card.commentsOpen ? 'chat_bubble' : 'chat_bubble_outline' }}</mat-icon>
        <span *ngIf="card.commentCount > 0"
          class="eazix-exhibition-likers-tip"
          aria-hidden="true">
          <span *ngFor="let n of topLikers(card.recentCommenters)"
            class="eazix-exhibition-likers-name"
            [attr.title]="n">{{ shortAuthorName(n) }}</span>
          <span *ngIf="hasMoreCommenters()" class="eazix-exhibition-likers-more">...</span>
        </span>
      </span>
      <span>{{ card.commentCount }}</span>
    </button>
  </div>
</div>

<div class="eazix-exhibition-comments-clip"
  [class.is-open]="card.commentsOpen">
  <div class="eazix-exhibition-comments-fold">
    <div *ngIf="focusLayout || card.commentsMounted" class="eazix-exhibition-comments"
      [class.is-empty]="suppressComments || (!card.commentsLoading && !card.comments.length && card.likeCount <= 0)"
      [class.no-send]="!(card.draftComment || '').trim() && !card.commenting"
      (click)="$event.stopPropagation()">
      <div class="wall-card-social-owner">
        <ng-content select="[wallOwner]"></ng-content>
      </div>

      <div *ngIf="!suppressComments && (card.commentsOpen || card.likeCount > 0)"
        class="eazix-exhibition-liked-block">
        <div class="eazix-exhibition-liked-names">
          <button *ngIf="focusLayout"
            type="button"
            class="eazix-exhibition-stat-btn eazix-exhibition-like-hit eazix-exhibition-liked-toggle"
            [class.eazix-exhibition-stat-liked]="card.likedByMe"
            [disabled]="card.liking"
            (click)="onLike($event)"
            [attr.aria-label]="'wall.exhibition.like' | translate">
            <mat-icon>{{ card.likedByMe ? 'favorite' : 'favorite_border' }}</mat-icon>
            <span>{{ card.likeCount }}</span>
          </button>
          <span *ngFor="let n of visibleLikers()"
            class="eazix-exhibition-liked-pill"
            [class.wall-truncated-name]="isLikerNameTruncated(n)"
            [class.c-pointer]="isLikerNameTruncated(n)"
            #likerTip="matTooltip"
            [matTooltip]="n"
            matTooltipPosition="above"
            matTooltipShowDelay="1000000"
            matTooltipHideDelay="0"
            matTooltipTouchGestures="off"
            [matTooltipDisabled]="!isLikerNameTruncated(n)"
            (click)="showTruncatedNameTip($event, likerTip, n)"
            (mouseleave)="hideTruncatedNameTip(likerTip)">
            <span class="wall-truncated-name-label">{{ likerDisplayName(n) }}</span>
          </span>
          <button *ngIf="canExpandLikers()"
            type="button"
            class="eazix-exhibition-liked-more"
            (click)="toggleLikersExpand($event)">
            {{ (card.likersExpanded ? 'wall.exhibition.less' : 'wall.exhibition.more') | translate }}
          </button>
        </div>
      </div>

      <div *ngIf="!suppressComments && card.commentsLoading && commentsLoadReservePx() > 0"
        class="eazix-exhibition-comments-reserve"
        [style.height.px]="commentsLoadReservePx()"
        aria-hidden="true"></div>
      <ul *ngIf="!suppressComments && visibleComments().length"
        class="eazix-exhibition-comments-list mb-0"
        [attr.data-comments-list]="card._id">
        <li *ngFor="let thread of visibleComments(); trackBy: trackCommentThread"
          class="eazix-exhibition-comment-thread">
          <ng-container
            *ngTemplateOutlet="commentRowTpl; context: { $implicit: thread.comment }">
          </ng-container>

          <button type="button"
            class="eazix-exhibition-reply-btn"
            [class.is-open]="thread.comment.replying"
            (click)="toggleReply(thread.comment, $event)">
            <mat-icon>{{ isRTL ? 'subdirectory_arrow_left' : 'subdirectory_arrow_right' }}</mat-icon>
            <span>{{ 'wall.exhibition.reply' | translate }}</span>
          </button>

          <div *ngIf="thread.comment.replying"
            class="eazix-exhibition-comment-compose eazix-exhibition-reply-compose"
            [class.no-send]="!(thread.comment.draftReply || '').trim() && !thread.comment.commentingReply"
            [attr.data-reply-compose]="thread.comment._id">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 eazix-exhibition-comment-field">
              <textarea matInput
                rows="1"
                [(ngModel)]="thread.comment.draftReply"
                (input)="onReplyInput($event, thread.comment)"
                (keydown.control.enter)="$event.preventDefault(); submitReply(thread.comment)"
                (keydown.meta.enter)="$event.preventDefault(); submitReply(thread.comment)"
                [placeholder]="'wall.exhibition.write-reply' | translate"
                maxlength="1000"
                [attr.data-reply-edit]="thread.comment._id">
              </textarea>
            </mat-form-field>
            <button
              type="button" mat-button color="primary"
              class="rounded-pill eazix-exhibition-send-comment-btn"
              [attr.data-reply-send]="thread.comment._id"
              [disabled]="thread.comment.commentingReply || !(thread.comment.draftReply || '').trim()"
              (click)="submitReply(thread.comment)">
              {{ (thread.comment.commentingReply ? 'wall.exhibition.sending' : 'wall.exhibition.send-reply') | translate }}
            </button>
          </div>

          <ul *ngIf="thread.replies?.length" class="eazix-exhibition-replies mb-0">
            <li *ngFor="let r of thread.replies; trackBy: trackCommentById">
              <ng-container
                *ngTemplateOutlet="commentRowTpl; context: { $implicit: r }">
              </ng-container>
            </li>
          </ul>
        </li>
      </ul>
      <div class="eazix-exhibition-comments-end-spacer" aria-hidden="true"></div>
    </div>
  </div>
</div>
</div>
<div *ngIf="!hideCommentCompose && (focusLayout ? card.commentsMounted : card.commentsOpen)"
  class="eazix-exhibition-comment-compose"
  [class.eazix-exhibition-compose-dock]="focusLayout"
  [class.is-reply-compose-open]="hasOpenReply()"
  [class.no-send]="!(card.draftComment || '').trim() && !card.commenting">
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 eazix-exhibition-comment-field">
    <textarea matInput
      rows="1"
      [(ngModel)]="card.draftComment"
      (input)="onComposeInput($event)"
      (keydown.control.enter)="$event.preventDefault(); submitComment()"
      (keydown.meta.enter)="$event.preventDefault(); submitComment()"
      [placeholder]="'wall.exhibition.write-comment' | translate"
      maxlength="1000"
      [attr.data-compose-edit]="card._id">
    </textarea>
  </mat-form-field>
  <button *ngIf="(card.draftComment || '').trim() || card.commenting"
    type="button" mat-button color="primary"
    class="rounded-pill eazix-exhibition-send-comment-btn"
    [attr.data-compose-send]="card._id"
    [disabled]="card.commenting"
    (click)="submitComment()">
    {{ (card.commenting ? 'wall.exhibition.sending' : 'wall.exhibition.send-comment') | translate }}
  </button>
</div>

<ng-template #commentRowTpl let-c>
  <div class="eazix-exhibition-comment-row" [attr.data-comment-id]="c._id">
    <div class="eazix-exhibition-comment-avatar"
      [attr.aria-label]="c.authorName || ('wall.personal.anonymous' | translate)">
      <img *ngIf="c.authorImageURL" [src]="c.authorImageURL" alt=""
        referrerpolicy="no-referrer"
        (error)="onCommentAvatarError(c)">
      <span *ngIf="!c.authorImageURL">{{ commentInitial(c) }}</span>
    </div>
    <div class="eazix-exhibition-comment-body">
      <div class="eazix-exhibition-comment-meta">
        <span class="eazix-exhibition-comment-uname"
          [class.wall-truncated-name]="isCommentAuthorNameTruncated(c.authorName)"
          [class.c-pointer]="isCommentAuthorNameTruncated(c.authorName)"
          #commentNameTip="matTooltip"
          [matTooltip]="c.authorName || ''"
          matTooltipPosition="above"
          matTooltipShowDelay="1000000"
          matTooltipHideDelay="0"
          matTooltipTouchGestures="off"
          [matTooltipDisabled]="!isCommentAuthorNameTruncated(c.authorName)"
          (click)="showTruncatedNameTip($event, commentNameTip, c.authorName)"
          (mouseleave)="hideTruncatedNameTip(commentNameTip)">
          <span class="wall-truncated-name-label">{{ c.authorName ? commentAuthorDisplayName(c.authorName) : ('wall.personal.anonymous' | translate) }}</span>
        </span>
        <span *ngIf="c.created" class="eazix-exhibition-comment-time">{{ commentTimeLabel(c) }}</span>
      </div>
      <div *ngIf="!c.editing" class="eazix-exhibition-comment-text-row">
        <p class="eazix-exhibition-comment-text mb-0"
          [wallCommentClamp]="!isCommentTextExpanded(c)"
          (wallCommentOverflow)="onCommentTextOverflow(c._id, $event)">{{ c.text }}</p>
        <button *ngIf="showCommentTextMore(c)"
          type="button"
          class="eazix-exhibition-comment-text-more"
          (click)="expandCommentText(c, $event)">{{ 'wall.exhibition.more' | translate }}</button>
        <button *ngIf="showCommentTextLess(c)"
          type="button"
          class="eazix-exhibition-comment-text-more"
          (click)="collapseCommentText(c, $event)">{{ 'wall.exhibition.less' | translate }}</button>
      </div>
      <div *ngIf="c.editing" class="eazix-exhibition-comment-edit-wrap">
        <textarea
          class="eazix-exhibition-comment-edit-input"
          [class.has-save]="isCommentDirty(c)"
          rows="1"
          [(ngModel)]="c.draftText"
          maxlength="1000"
          [disabled]="c.saving"
          [attr.data-comment-edit]="c._id"
          (click)="$event.stopPropagation()"
          (input)="resizeCommentField($event)"
          (keydown.escape)="cancelEditComment(c); $event.preventDefault()">
        </textarea>
        <button *ngIf="isCommentDirty(c)"
          type="button"
          class="eazix-exhibition-comment-save"
          [disabled]="c.saving || !(c.draftText || '').trim()"
          (click)="saveEditComment(c); $event.stopPropagation()">
          {{ (c.saving ? 'wall.exhibition.sending' : 'wall.exhibition.save-comment') | translate }}
        </button>
      </div>
      <div class="eazix-exhibition-comment-like-row">
        <button type="button"
          class="eazix-exhibition-comment-like eazix-exhibition-like-hit"
          [class.is-liked]="c.likedByMe"
          [disabled]="c.liking"
          (click)="onCommentLike(c, $event)"
          [attr.aria-label]="'wall.exhibition.like' | translate">
          <mat-icon>{{ c.likedByMe ? 'favorite' : 'favorite_border' }}</mat-icon>
          <span>{{ c.likeCount || 0 }}</span>
          <span *ngIf="(c.likeCount || 0) > 0 && topLikers(c.recentLikers).length"
            class="eazix-exhibition-likers-tip eazix-exhibition-likers-tip-light"
            aria-hidden="true">
            <span *ngFor="let n of topLikers(c.recentLikers)"
              class="eazix-exhibition-likers-name"
              [attr.title]="n">{{ shortAuthorName(n) }}</span>
            <span *ngIf="(c.likeCount || 0) > 3" class="eazix-exhibition-likers-more">...</span>
          </span>
        </button>
        <button *ngIf="(c.likeCount || 0) > 0"
          type="button"
          class="eazix-exhibition-comment-likers-toggle"
          [class.is-open]="c.likersExpanded"
          (click)="toggleCommentLikers(c, $event)"
          [attr.aria-label]="(c.likersExpanded ? 'wall.exhibition.less' : 'wall.exhibition.more') | translate">
          <mat-icon>{{ c.likersExpanded ? 'remove' : 'add' }}</mat-icon>
        </button>
        <div *ngIf="isMyComment(c)" class="eazix-exhibition-comment-tools">
          <button type="button"
            class="eazix-exhibition-comment-pen"
            [class.is-editing]="c.editing"
            [disabled]="c.saving"
            (click)="c.editing ? cancelEditComment(c) : startEditComment(c, $event); $event.stopPropagation()"
            [attr.aria-label]="(c.editing ? 'wall.exhibition.remove-pen' : 'wall.exhibition.edit-comment') | translate">
            <mat-icon>{{ c.editing ? 'edit_off' : 'edit' }}</mat-icon>
          </button>
          <span *ngIf="c.editing" class="eazix-exhibition-comment-delete-wrap">
            <button type="button"
              class="eazix-exhibition-comment-delete"
              [matMenuTriggerFor]="deleteCommentMenu"
              [disabled]="c.saving"
              (click)="$event.stopPropagation()"
              [attr.aria-label]="'wall.exhibition.delete-comment' | translate">
              <mat-icon>delete</mat-icon>
            </button>
            <mat-menu #deleteCommentMenu="matMenu" xPosition="before" yPosition="below">
              <button mat-menu-item
                class="eazix-exhibition-comment-delete-menu-item"
                [disabled]="c.saving"
                (click)="deleteComment(c); $event.stopPropagation()">
                <mat-icon>delete_forever</mat-icon>
                <span>{{ 'wall.exhibition.delete-comment' | translate }}</span>
              </button>
            </mat-menu>
          </span>
        </div>
        <div *ngIf="c.likersExpanded && commentLikers(c).length"
          class="eazix-exhibition-comment-likers">
          <span *ngFor="let n of commentLikers(c)"
            class="eazix-exhibition-liked-pill"
            [class.wall-truncated-name]="isLikerNameTruncated(n)"
            [class.c-pointer]="isLikerNameTruncated(n)"
            #commentLikerTip="matTooltip"
            [matTooltip]="n"
            matTooltipPosition="above"
            matTooltipShowDelay="1000000"
            matTooltipHideDelay="0"
            matTooltipTouchGestures="off"
            [matTooltipDisabled]="!isLikerNameTruncated(n)"
            (click)="showTruncatedNameTip($event, commentLikerTip, n)"
            (mouseleave)="hideTruncatedNameTip(commentLikerTip)">
            <span class="wall-truncated-name-label">{{ likerDisplayName(n) }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
